module.exports = {
  API_URL: process.env.REACT_APP_API_URL,
  PERSIST_WHITELIST_MODELS: ['Restaurant']
};
